"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./OverflowSet"), exports);
tslib_1.__exportStar(require("./OverflowSet.base"), exports);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/OverflowSet/index.js
// module id = 854
// module chunks = 0